import classNames from 'classnames';
import React, { RefObject } from 'react';
import Skeleton from 'react-loading-skeleton';
import { defaultImageSrc } from 'src/constants/main';
import { debounce } from 'src/utils/perfomance';
import './style.scss';

interface IProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  aspectRatio?: number | 'none';
  refreshing?: boolean;
  wrapperClassName?: string;
  skeletonClassName?: string;
}

interface IState {
  height: number | undefined;
  loading: boolean;
  src: string | undefined;
}

export default class Image extends React.PureComponent<IProps, IState> {
  aspectRatio: number | null = typeof this.props.aspectRatio === 'string' ? null : this.props.aspectRatio || 1.5;
  image: RefObject<HTMLImageElement> = React.createRef();
  state = {
    height: undefined,
    loading: true,
    src: this.props.src,
  };

  componentDidMount = () => {
    if (typeof this.props.aspectRatio === 'string' || !this.aspectRatio) return;

    if (this.image.current) {
      const height = this.image.current.clientWidth / this.aspectRatio;
      this.setState({ height });
    }
    window.addEventListener('resize', this.onResize);
  };

  static getDerivedStateFromProps = (props: IProps, state: IState) => {
    if (props.src !== state.src && state.src !== defaultImageSrc) {
      return {
        ...state,
        src: props.src,
      };
    }
    return null;
  };

  onImageLoad = () => {
    this.setState({ loading: false });
  };

  onImageLoadError = () => {
    this.setState({ loading: false, src: defaultImageSrc });
  };

  handleResize = () => {
    if (typeof this.props.aspectRatio === 'string' || !this.aspectRatio) return;

    if (this.image.current) {
      const height = this.image.current.clientWidth / this.aspectRatio;
      this.setState({ height });
    }
  };

  onResize = debounce(this.handleResize, 100);

  render() {
    // eslint-disable-next-line unused-imports/no-unused-vars
    const { aspectRatio, wrapperClassName, skeletonClassName, refreshing, ...props } = this.props;

    return (
      <div className={classNames('image-wrapper', wrapperClassName)}>
        <img
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          alt={this.props.alt || this.state.src}
          src={this.state.src}
          onLoad={this.onImageLoad}
          onError={this.onImageLoadError}
          loading="lazy"
          className={classNames('image full-width', props.className)}
          style={{ height: this.state.height }}
          ref={this.image}
        />
        {this.state.loading || this.props.refreshing ? (
          <Skeleton height={this.state.height} className={classNames('image-skeleton', skeletonClassName)} />
        ) : null}
      </div>
    );
  }
}
